import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { FiChevronRight } from 'react-icons/fi';
// import { AiFillEye } from 'react-icons/ai';
import { MdSquare } from 'react-icons/md';
import { BsEyeSlash, BsEye } from 'react-icons/bs';
import { CredusButton, CredusText, color } from 'ui';

import { ProceedIcon, ReUploadIcon } from '../../../../assets/images/svgs';
import { TestContext } from '../../../../contexts/TestContext';
import TestUploadTable from './tables/TestUploadTable';
import TestConfirmAction from './modals/TestConfirmAction';

export interface BulletProps {
  color?: string;
  background?: string;
  border?: string;
}
export interface DivProps {
  gap?: string;
  width?: string;
  justify?: string;
}

interface TestReUploadProps {
  setConfigureTest: React.Dispatch<React.SetStateAction<boolean>>;
  setCreateTest: React.Dispatch<React.SetStateAction<boolean>>;
  setTestReUpload: React.Dispatch<React.SetStateAction<boolean>>;
}

const TestReUpLoad = ({
  setConfigureTest,
  setCreateTest,
  setTestReUpload,
}: TestReUploadProps) => {
  const [confirmation, setConfirmation] = useState(false);
  const [text, setText] = useState('');
  const [showAnswers, setShowAnswers] = useState(true);
  const [confirmFunction, setConfirmFunction] = useState<() => void>();
  const [selectedQuestions, setSelectedQuestions] = useState<string[]>(['']);
  const { testData, setTestData, testCategory } = useContext(TestContext);

  const deleteAllQuestions = () => {
    setTestData((prev) => ({ ...prev, questions: [] }));
    setConfirmation(false);
  };

  const reUploadQuestions = () => {
    setTestReUpload(false);
    setCreateTest(true);
    setConfirmation(false);
  };

  const handleSelectAll = () => {
    const testQuestions = testData.questions.map((el) => el.text);
    setSelectedQuestions((prev) =>
      prev?.length == testQuestions?.length ? [] : [...testQuestions]
    );
  };

  const handleDelete = () => {
    setConfirmation(true);
    setText(
      'You are about to delete all questions, your current data would be lost. Do you want to continue?'
    );
    setConfirmFunction(() => deleteAllQuestions);
  };
  const handleReUpload = () => {
    setConfirmation(true);
    setText(
      'You are about to re-upload your questions, your current data would be lost. Do you want to continue?'
    );

    setConfirmFunction(() => reUploadQuestions);
  };

  const handleShowAnswers = () => {
    setShowAnswers((prev) => !prev);
  };

  const handleProceed = () => {
    setConfigureTest(true);
  };

  return (
    <Container>
      {confirmation && (
        <TestConfirmAction
          showActionConfirmation={confirmation}
          setShowActionConfirmation={setConfirmation}
          text={text}
          action={confirmFunction}
        />
      )}
      <Header>
        <Div>
          <BulletDiv>
            <Bullet color={color.white} background={color.primary}>
              <CredusText size="xs" color={color.white}>
                1
              </CredusText>
            </Bullet>
            <CredusText size="md">Upload</CredusText>
          </BulletDiv>
          <FiChevronRight color="#000929" />
          <BulletDiv>
            <Bullet background={color.lightPurple}>
              <CredusText size="xs">2</CredusText>
            </Bullet>
            <CredusText size="md">Configure</CredusText>
          </BulletDiv>
          <FiChevronRight color="#000929" />
          <BulletDiv>
            <Bullet background={color.lightPurple}>
              <CredusText size="xs">3</CredusText>
            </Bullet>
            <CredusText size="md">Review & Publish</CredusText>
          </BulletDiv>
        </Div>
        {/* <Div>
          <AiFillEye />
          <CredusText size="md">Preview</CredusText>
        </Div> */}
      </Header>

      <SubHeader>
        <CredusText size="md">
          Test: <strong>{testCategory}</strong>
        </CredusText>

        <CredusText size="md">
          Status: <strong> In progress</strong>
        </CredusText>
      </SubHeader>
      <NoteDiv>
        <CredusText size="sm">
          Note: The following test upload should only be done on a single
        </CredusText>
        <FlexDiv>
          <ul>
            <li>
              <CredusText size="xs">
                MCQ - Multiple choice Question, SC - Single Choice, SA - Short
                answer
              </CredusText>
            </li>
            <li>
              <CredusText size="xs">
                Options highlighted in GREEN are recorded as the correct answer
                options
              </CredusText>
            </li>
            <li>
              <CredusText size="xs">
                Options highlighted in YELLOW are recorded as the wrong answer
                options
              </CredusText>
            </li>
          </ul>
          <ul>
            <li>
              <CredusText size="xs">Validate the data uploaded</CredusText>
            </li>
            <li>
              <CredusText size="xs">
                Delete any question of your choice as when needed
              </CredusText>
            </li>
            <li>
              <CredusText size="xs">
                You’re not allowed to edit imported questions
              </CredusText>
            </li>
          </ul>
          <ul>
            <li>
              <CredusText size="xs">
                Select all and proceed to Configure
              </CredusText>
            </li>

            <li>
              <CredusText size="xs">
                Only selected tests will be uploaded to the question bank
              </CredusText>
            </li>
          </ul>
        </FlexDiv>
      </NoteDiv>
      <BtnDiv>
        <Div>
          <CredusButton
            outlined
            onClick={handleSelectAll}
            disabled={testData.questions.length == 0}
          >
            Select All
          </CredusButton>
          <CredusButton
            onClick={handleDelete}
            outlined
            disabled={
              !(
                testData.questions.map((el) => el.text)?.length ==
                selectedQuestions?.length
              )
            }
          >
            Delete All
          </CredusButton>
          <CredusButton
            onClick={handleReUpload}
            outlined
            preffix={<ReUploadIcon />}
          >
            Re-upload
          </CredusButton>
        </Div>
        <Div gap="3rem">
          <Div>
            <Div gap=".5rem">
              <MdSquare color="#0A8B38" />
              <CredusText size="sm">Correct</CredusText>
            </Div>
            <Div gap=".3rem">
              <MdSquare color="#FDC453" />
              <CredusText size="sm">Wrong</CredusText>
            </Div>
          </Div>
          <CredusButton
            onClick={handleShowAnswers}
            outlined
            preffix={
              showAnswers ? (
                <BsEyeSlash color={color.primary} size={'1rem'} />
              ) : (
                <BsEye color={color.primary} size={'1rem'} />
              )
            }
            disabled={testData.questions?.length == 0}
          >
            {showAnswers ? 'Hide Answers' : 'Show Answers'}
          </CredusButton>
          <CredusButton
            onClick={handleProceed}
            suffix={<ProceedIcon />}
            disabled={testData.questions?.length == 0}
          >
            Proceed
          </CredusButton>
        </Div>
      </BtnDiv>
      <TestUploadTable
        testData={testData}
        setTestData={setTestData}
        selectedQuestions={selectedQuestions}
        setSelectedQuestions={setSelectedQuestions}
        showAnswers={showAnswers}
      />
    </Container>
  );
};

export default TestReUpLoad;

const Container = styled.div`
  background: ${color.white};
  padding: 2rem 1rem;
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Div = styled.div<DivProps>`
  display: flex;
  gap: ${({ gap }) => (gap ? gap : '1rem')};
  align-items: center;
`;

const BulletDiv = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

const Bullet = styled.div<BulletProps>`
  height: 28px;
  width: 28px;
  border-radius: 50%;
  background: ${(props) => props.background};
  color: ${(props) => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SubHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3rem;
  padding-top: 3.5rem;
  width: 100%;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(0, 9, 41, 0.15);
`;

const NoteDiv = styled.div`
  width: 100%;
  min-height: 108px;
  background: #f8f8f8;
  padding: 1rem 1.5rem;
  margin-top: 1.5rem;
`;

const FlexDiv = styled.div`
  display: flex;
`;

const BtnDiv = styled.div`
  width: 100%;
  margin-top: 2rem;
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: space-between;
`;
